import { render, staticRenderFns } from "./Safeguarding.vue?vue&type=template&id=18929cea&scoped=true&"
import script from "./Safeguarding.vue?vue&type=script&lang=js&"
export * from "./Safeguarding.vue?vue&type=script&lang=js&"
import style0 from "./Safeguarding.vue?vue&type=style&index=0&id=18929cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18929cea",
  null
  
)

export default component.exports